import { ReactNode } from 'react';
import * as S from './InfoCard.styled';

const InfoCard = ({ children }: { children: ReactNode }) => {
  return <S.Container>{children}</S.Container>;
};

export default InfoCard;
